"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TechnologiesPicker = void 0;
var react_1 = __importStar(require("react"));
var styles_1 = require("@material-ui/core/styles");
var technologies_picker_styles_1 = require("./technologies_picker_styles");
var all_technologies_picker_1 = require("./all_technologies_picker/all_technologies_picker");
var selected_technologies_1 = require("./selected_technologies/selected_technologies");
var technologies_picker_context_1 = require("./technologies_picker_context");
var useStyles = styles_1.makeStyles(technologies_picker_styles_1.styles);
var TechnologiesPicker = function (_a) {
    var isMobile = _a.isMobile, _b = _a.selectedValues, selectedValues = _b === void 0 ? [] : _b, onAddItem = _a.onAddItem, onDeleteItem = _a.onDeleteItem, onArrayChange = _a.onArrayChange, onArrayItemChange = _a.onArrayItemChange, technologies = _a.technologies, _c = _a.classes, receivedClasses = _c === void 0 ? {} : _c, translations = _a.translations, content = _a.content;
    var classes = useStyles({ classes: receivedClasses, isMobile: isMobile });
    var technoPickerContext = react_1.useMemo(function () { return ({
        technologies: technologies,
        translations: translations,
    }); }, [technologies, translations]);
    return (react_1.default.createElement(technologies_picker_context_1.TechnologiesPickerContext.Provider, { value: technoPickerContext },
        react_1.default.createElement("div", { className: classes.container },
            react_1.default.createElement(all_technologies_picker_1.AllTechnologiesPicker, { isMobile: isMobile, technologies: technologies, selectedItems: selectedValues, onAdd: onAddItem, onDelete: onDeleteItem, noResultsElement: content === null || content === void 0 ? void 0 : content.noResults, additionalInformations: content === null || content === void 0 ? void 0 : content.additionalInformations, classes: {
                    container: classes.allTechnologies,
                    technologiesList: classes.technologiesList,
                } }),
            !isMobile && react_1.default.createElement("div", { className: classes.divider }),
            !isMobile && (react_1.default.createElement("div", { className: classes.column }, content === null || content === void 0 ? void 0 :
                content.additionalInformations,
                react_1.default.createElement(selected_technologies_1.SelectedTechnologies, { className: classes.selectedTechnologies, items: selectedValues, onDelete: onDeleteItem, onChange: onArrayChange, onItemChange: onArrayItemChange }))))));
};
exports.TechnologiesPicker = TechnologiesPicker;
